import {
  enhancedFetch,
  getProxycadorHost,
} from "src/features/kyc/imports/utils";

interface IdentificationForSuspendedAccountResponse {
  status: string;
  skipAllowed: boolean;
  externalLink: string;
}

export const requestIdentificationForSuspendedAccount = (
  signal?: AbortSignal
): Promise<IdentificationForSuspendedAccountResponse> =>
  enhancedFetch(
    `${getProxycadorHost()}/identityvalidator/v2/requestIdentificationForSuspendedAccount`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      signal,
    }
  ).then((response) => response.json());
